import { FC } from 'react';

import { ImagesApp } from '../../constants/images';
import { useEventContext } from '../../hooks/contexts/event.context';
import { DetailTagProps } from '../../types/ticket';
import formatNumericValue from '../../utils/formatNumericValue';
import * as Style from './styles.tags';

type CupomProps = {
  coupon: DetailTagProps;
}

const Cupom: FC<CupomProps> = ({ coupon }) => {
  const { currencyFormat } = useEventContext();

  const isPercentual = coupon.typeDiscount === 'percentual';

  return (
    <Style.Cupom id="coupon-tag">
      <img id="coupon-tag-image" src={ImagesApp.svg.coupon} alt="Coupon" />
      <span id="coupon-tag-text">{
        isPercentual ? `${coupon.value}% OFF`
          : `${formatNumericValue({ value : coupon.value, discount : 0, currencyFormat })} OFF`
      }</span>
    </Style.Cupom>
  );
};

export default Cupom;
